import queryString from 'query-string'
import {get} from '../utils'
import {WINDOW} from '../constants/environment'

const REQUEST = 'REQUEST'
const SUCCESS = 'SUCCESS'
const FAILURE = 'FAILURE'

export const requestTypes = {
  REQUEST,
  SUCCESS,
  FAILURE,
}

export const createRequestTypes = base =>
  [REQUEST, SUCCESS, FAILURE].reduce((acc, type) => {
    acc[type] = `${base}_${type}`
    return acc
  }, {})

export function action(type, payload = {}) {
  return {type, payload}
}

export const generateActionTypes = (names, prefix = '', suffix = '') =>
  names.reduce((t, name) => ({...t, [name]: `${prefix}${name}${suffix}`}), {})

export const getInitialFromQuery = key => WINDOW &&
  get(key, queryString.parse(WINDOW.location.search))



// WEBPACK FOOTER //
// ./src/store/utils.js